import { render } from "./CatList.vue?vue&type=template&id=1f205fa1"
import script from "./CatList.vue?vue&type=script&lang=js"
export * from "./CatList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__